import React from "react";

function LandingPage() {
    return (
      <div className="min-vh-100 bg-white text-dark">
        <header className="py-3 shadow-sm border-bottom">
          <div className="container d-flex justify-content-between align-items-center">
            <h1 className="h4 fw-bold">SimCode</h1>
            <nav>
              <a href="#about" className="me-3 text-decoration-none">About</a>
              <a href="#services" className="me-3 text-decoration-none">Services</a>
              <a href="#contact" className="text-decoration-none">Contact</a>
            </nav>
          </div>
        </header>
  
        <section className="text-center py-5 bg-light">
          <div className="container">
            <h2 className="display-5 fw-bold mb-3">
              Innovative Software Solutions for Modern Businesses
            </h2>
            <p className="mb-4">
              At SimCode, we build powerful digital tools that help your business scale, innovate, and succeed.
            </p>
            <a href="#contact" className="btn btn-primary btn-lg">Get Started</a>
          </div>
        </section>
  
        <section id="about" className="py-5">
          <div className="container">
            <h3 className="h2 fw-bold mb-4">About SimCode</h3>
            <p>
              SimCode is a tech consultancy founded by Daniel Zaremba, an experienced software engineer with over 7 years of expertise in software development and automated testing. With a strong background in Java, REST APIs, and test frameworks, SimCode brings deep technical know-how to every project.
            </p>
            <p>
              Daniel has worked with major organizations including Nordea, Cybercom, and Knowit, leading initiatives in test automation, CI/CD integration, and scalable web application development. SimCode builds on that experience to offer efficient, maintainable, and future-proof software solutions.
            </p>
          </div>
        </section>
  
        <section id="services" className="py-5 bg-light">
          <div className="container">
            <h3 className="h2 fw-bold mb-4">Our Services</h3>
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100">
                  <div className="card-body">
                    <h4 className="card-title">Test Automation</h4>
                    <p className="card-text">Design and implementation of automated testing frameworks in Java and REST Assured, focused on maintainability, modularity, and execution speed.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100">
                  <div className="card-body">
                    <h4 className="card-title">Full-Stack Development</h4>
                    <p className="card-text">Development of scalable web applications using Java, AngularJS, and modern frontend and backend technologies tailored to client needs.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100">
                  <div className="card-body">
                    <h4 className="card-title">CI/CD & DevOps Support</h4>
                    <p className="card-text">Streamlining software delivery through Continuous Integration, test automation pipelines, and infrastructure management using tools like Jenkins and Git.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
  
        <section id="contact" className="py-5 text-center">
          <div className="container">
            <h3 className="h2 fw-bold mb-4">Get in Touch</h3>
            <p className="mb-3">
              Ready to start your next project? Let’s build something amazing together.
            </p>
            <p className="mb-2">📧 <a href="mailto:contact@simcodelab.com" className="text-decoration-none">contact@simcodelab.com</a></p>
            <p className="mb-4">📞 +48 794 584 616</p>
            <a href="#" className="btn btn-primary btn-lg">Contact Us</a>
          </div>
        </section>
  
        <footer className="py-3 text-center border-top">
          <div className="container">
            <small className="text-muted">&copy; {new Date().getFullYear()} SimCode. All rights reserved.</small>
          </div>
        </footer>
      </div>
    );
  };

export { LandingPage };